export default __webpack_public_path__ + "static/media/IMG_3846.bc617bb1.webp";